/**
 * Variant inventory cap + price sync
 * 商品カードの状態プルダウンが変更されたとき、
 * - 選択バリアントの在庫数に応じて数量入力の max を動的更新
 * - バリアントの価格を上部の価格表示エリアに反映 (セール時は取消線元値も)
 */

(function () {
  'use strict';

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.card__variant-select');
    if (!select) return;

    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    const form = select.closest('form');
    if (!form) return;

    // ---------- 1) 数量入力の max を更新 ----------
    const qtyInput = form.querySelector('input[name="quantity"]');
    if (qtyInput) {
      const maxStock = selectedOption.dataset.max;
      if (maxStock && maxStock !== '') {
        const maxNum = parseInt(maxStock, 10);
        qtyInput.max = maxNum;
        const currentVal = parseInt(qtyInput.value, 10) || 1;
        if (currentVal > maxNum) {
          qtyInput.value = maxNum;
        }
      } else {
        qtyInput.removeAttribute('max');
      }
    }

    // ---------- 2) 価格表示を更新 ----------
    const wrapper = select.closest('.card-wrapper, .card-wrapper--minimal');
    if (!wrapper) return;

    const priceEl = wrapper.querySelector('[data-variant-price]');
    const compareEl = wrapper.querySelector('[data-variant-compare-price]');
    const priceText = selectedOption.dataset.price;
    const compareText = selectedOption.dataset.comparePrice;
    const onSale = selectedOption.dataset.onSale === 'true';

    if (priceEl && priceText) {
      priceEl.textContent = priceText;
      if (onSale) {
        priceEl.classList.add('card__variant-price--sale');
      } else {
        priceEl.classList.remove('card__variant-price--sale');
      }
    }

    if (compareEl) {
      if (onSale && compareText) {
        compareEl.textContent = compareText;
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.setAttribute('hidden', '');
      }
    }
  });
})();
